import { baseApi } from "@/config/http-common";

class UserDataService {
  getAll(params?: Record<string, unknown>): Promise<any> {
    return baseApi.get("/users/users/list", { params });
  }

  get(id: any): Promise<any> {
    return baseApi.get(`/users/users/view/${id}`);
  }

  create(data: any): Promise<any> {
    return baseApi.post("/users/users/create", data);
  }

  update(id: any, data: any): Promise<any> {
    return baseApi.put(`/users/users/update/${id}`, data);
  }

  delete(id: string, coordinatorId?: string): Promise<any> {
    return baseApi.delete(`/users/users/delete/${id}`, {
      params: coordinatorId != null ? { coordinatorId } : undefined,
    });
  }

  getUserRoles(): Promise<any> {
    return baseApi.get("/users/users/sub-data/roles");
  }

  getUserJobs(): Promise<any> {
    return baseApi.get("/users/users/sub-data/jobs");
  }

  getUserCompanies(): Promise<any> {
    return baseApi.get("/users/users/sub-data/companies");
  }

  getCoordinators(): Promise<any> {
    return baseApi.get("/users/users/sub-data/coordinators");
  }
}

export default new UserDataService();
